import { relatedGroupBus } from "@/event/product/relatedGroupeBus"
import { forceSelectOptionHappy } from "@/happyTheme/event/product/forceSelectOptionHappy"
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy"
import type { Option } from "@/storage/products"
import type { Ref } from "vue"

export function decrementOptionValueHappy(optionValueId: number,
    optionId: number,
    counterOptionValue: Ref<number>,
    option: Option) {
    forceSelectOptionHappy.value = false
    if (counterOptionValue.value > 0) {
        const propsOption = option
        const optionValueFind = propsOption.values.find(
            (e) => e.option_value_id === optionValueId
        )

        if (propsOption.type === 'radio' && optionValueFind) {
            selectOptionsListHappy.value[
                propsOption.option_id
            ].selected_values.radio_option = {
                option_value_id: 0,
                option_value_name: '',
                option_value_image: '',
                option_value_price: ''
            }

            propsOption.values.forEach((oF) => {
                if (oF.related_option_id.length === 0) return
                oF.related_option_id.forEach((roi) => {
                    if (!relatedGroupBus.value.includes(roi)) {
                        relatedGroupBus.value.push(roi)
                    }
                })
            })
            counterOptionValue.value--
            return
        }

        if (propsOption.type === 'select' || propsOption.type === 'checkbox') {
            const optionValueSelected =
                selectOptionsListHappy.value[optionId].selected_values.checkbox_option
            const optionValueFreeSelected = optionValueSelected.option_value_free
            const optionValuePaidSelected = optionValueSelected.option_value_paid

            const optionValueFreeIndex = optionValueFreeSelected.findIndex(
                (i) => i.option_value_id === optionValueId
            )
            const optionValuePaidIndex = optionValuePaidSelected.findIndex(
                (i) => i.option_value_id === optionValueId
            )

            if (optionValuePaidIndex !== -1) {
                optionValuePaidSelected.splice(optionValuePaidIndex, 1)
                if (
                    propsOption.free_option_count !== 0 &&
                    propsOption.max_option_count === 0
                ) {
                    optionValueSelected.quantity_paid++
                }
                counterOptionValue.value--
                return
            }

            if (optionValueFreeIndex !== -1) {
                optionValueFreeSelected.splice(optionValueFreeIndex, 1)

                if (optionValuePaidSelected.length === 0) {
                    optionValueSelected.quantity_free++
                    // return
                } else {
                    optionValuePaidSelected.forEach((e, idx) => {
                        if (
                            e.option_value_one_is_free !== true &&
                            e.option_value_special !== true &&
                            optionValuePaidSelected.length >= 1
                        ) {
                            optionValuePaidSelected.splice(idx, 1)

                            optionValueFreeSelected.push({
                                option_value_id: e.option_value_id,
                                option_value_name: e.option_value_name,
                                option_value_image: e.option_value_image,
                                option_value_price: '0',
                                option_value_reset: 0,
                                option_value_grup: '',
                                option_value_one_is_free: false,
                                option_value_special: false
                            })
                            optionValueSelected.quantity_paid++
                            return
                        } else if (
                            optionValueFreeSelected.length === 0 &&
                            optionValuePaidSelected.length === 1 &&
                            e.option_value_one_is_free === true &&
                            e.option_value_special !== true
                        ) {
                            optionValuePaidSelected.splice(idx, 1)

                            optionValueFreeSelected.push({
                                option_value_id: e.option_value_id,
                                option_value_name: e.option_value_name,
                                option_value_image: e.option_value_image,
                                option_value_price: '0',
                                option_value_reset: 0,
                                option_value_grup: '',
                                option_value_one_is_free: true,
                                option_value_special: false
                            })
                            optionValueSelected.quantity_paid++
                        } else {
                            optionValueSelected.quantity_free++
                        }
                    })
                }
                return
            }
        }
    }
}